import React from "react";
import { RippleButton } from "../../components/RippleButton";
import { ThemeToggle } from "../../components/ThemeToggle";
import logoImg from "../../assets/images/logo.webp";
import logoDarkImg from "../../assets/images/logo_dark.webp";
import ilHero from "../../assets/images/il_hero.webp";
import ilHeroDark from "../../assets/images/il_hero_dark.webp";
import { useHome } from "../../providers/HomeContext";
import { useTheme } from "../../providers/ThemeContext";
import resumePdf from "../../assets/files/Resume Ya'suf Dany.pdf";

interface HeroSectionProps {
  onNavigate: (route: string) => void;
}

export const HeroSection: React.FC<HeroSectionProps> = ({ onNavigate }) => {
  const { setScrollTarget } = useHome();
  const { theme } = useTheme();

  const handleDownloadResume = () => {
    window.open(resumePdf, "_blank");
  };

  const handleContactMe = () => {
    setScrollTarget(2);
  };

  return (
    <div className="w-full h-full flex flex-col justify-between p-[2vw] relative">
      {/* Header */}
      <div className="flex items-center justify-between w-full z-20 px-2 py-1 md:px-[1vw] md:py-[0.5vw]">
        {/* Logo */}
        <RippleButton
          color="bg-transparent"
          hoverColor="bg-gray-100/10"
          padding="p-3 md:p-[1vw]"
          onTap={() => {}}
          className="border-none"
        >
          <img
            src={theme === "dark" ? logoDarkImg : logoImg}
            alt="StudioCloud Logo"
            className="w-[20vw] md:w-[14vw] min-w-[160px] md:min-w-[120px] max-w-[268px] object-contain"
          />
        </RippleButton>

        {/* Navigation */}
        <div className="flex items-center gap-2 md:gap-4">
          <ThemeToggle />
        </div>
      </div>

      {/* Center Layout Panel */}
      <div className="flex-1 flex flex-col-reverse md:flex-row items-center justify-center gap-8 md:gap-0 w-full z-10">
        <div className="flex flex-col items-center md:items-start text-center md:text-left select-text">
          <h1 className="font-nunito text-[32px] md:text-[56px] font-black text-dark tracking-tight leading-tight">
            Hello, I’m Dany
          </h1>
          <p className="font-nunito text-base md:text-[24px] text-dark/50 mb-2">
            I'm a Mobile Developer
          </p>

          <div className="flex flex-col sm:flex-row items-center gap-4 sm:gap-0 mt-8 md:mt-8">
            <RippleButton
              text="Download Resume"
              onTap={handleDownloadResume}
              padding="px-8 py-3.5"
              enableShadow={true}
              className="w-full sm:w-auto font-rubik text-base font-normal"
            />
            <RippleButton
              text="Contact Me"
              color="bg-bg"
              textColor="text-primary"
              border="border-2 border-primary"
              hoverColor="bg-primary/10"
              onTap={handleContactMe}
              padding="px-8 py-3"
              className="w-full sm:w-auto sm:ml-6 font-rubik text-base font-normal"
            />
          </div>
        </div>

        {/* Illustration */}
        <div className="flex justify-center items-center md:ml-8 max-h-[30vh] md:max-h-[52vh]">
          <img
            src={theme === "dark" ? ilHeroDark : ilHero}
            alt="Dany Illustration"
            className="w-[70vw] max-w-[320px] md:w-[34vw] md:max-w-[550px] max-h-full object-contain pointer-events-none drop-shadow-xl"
          />
        </div>
      </div>

      {/* Spacing footer spacer */}
      <div className="h-[2vw] hidden md:block"></div>
    </div>
  );
};
